import { deleteOfficeType } from "../../../../../actions/Utilities/OfficeType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteOfficeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteOfficeType(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetOfficeTypes"]);
      toast.fire(
        "Success",
        "Office Type has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Office Types",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteOfficeType;
